// use lodash! https://lodash.com/docs/4.17.15
import tabs from './components/tabs';
const fndryThemeInitWrapper = () => {
  tabs();
};

window.fndryThemeInitWrapper = fndryThemeInitWrapper;

// eslint-disable-next-line no-unused-expressions
document.body ? fndryThemeInitWrapper() : document.addEventListener( 'DOMContentLoaded', fndryThemeInitWrapper, false );


$(window).on("scroll", function() {

    if($(window).scrollTop() > 50) {
        $("header").addClass("shrink-nav");
  
    } else {
        $("header").removeClass("shrink-nav");
      
    }
});
  $("header").hover(function(){
    $("header").removeClass("shrink-nav");
});

$("header").focus(function(){
    $("header").removeClass("shrink-nav");
});

const smallElements = document.querySelectorAll('small');
for (let i = 0; i < smallElements.length; i++) {
  smallElements[i].classList.add('fndry-text-legalText');
}
